<template>
  <div>
    <BlockUI
      v-show="$store.state.showBlock"
      message="Vui lòng chờ trong giây lát"
    >
      <sweetalert-icon
        icon="loading"
        size="12"
      />
    </BlockUI>
    <khach-hang-list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      @refetch-data="refetchData"
    />
    <nap-tien
      :is-nap-tien-sidebar-active.sync="isNapTienSidebarActive"
      @refetch-data="refetchData"
    />
    <tim-kiem
      :is-tim-kiem-sidebar-active.sync="isTimKiemSidebarActive"
      @refetch-data="refetchData"
    />

    <b-card
      no-body
      class="mb-0"
    >
      <b-card-header>
        <b-card-title>Danh sách đại lý</b-card-title>
        <b-dropdown
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="flat-primary"
          dropright
          text="Chức năng"
          :right="$store.state.appConfig.isRTL"
        >
          <b-dropdown-item @click="isAddNewUserSidebarActive = true">
            <feather-icon
              icon="UserPlusIcon"
              class="mr-50"
            />
            <span class="align-middle ml-50">Thêm đại lý</span>
          </b-dropdown-item>
          <b-dropdown-item @click="isTimKiemSidebarActive = true">
            <feather-icon
              icon="SearchIcon"
              class="mr-50"
            />
            <span class="align-middle ml-50">Tìm kiếm</span>
          </b-dropdown-item>
        </b-dropdown>
      </b-card-header>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        empty-text="Bạn không có đại lý nào"
        show-empty
        responsive="sm"
        stacked="md"
        :items="fetchDaiLyList"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        primary-key="id"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- A virtual column -->
        <template #cell(id)="data">
          <p class="text-right">
            {{ data.index+1 }}
          </p>
        </template>

        <!-- Column: User -->
        <template #cell(ma_dai_ly)="data">
          {{ data.item.ma_dai_ly }}<br>
          <b-media vertical-align="center">
            <small class="text-muted">Tuyến trên:</small>
            <b-link
              :to="{ name: 'xem-chi-tiet-dai-ly', params: { id: data.item.dai_ly_id } }"
              class="font-weight-bold d-block text-nowrap text-success"
            >
              {{ data.item.dai_ly }}
            </b-link>
          </b-media>
        </template>
        <template #cell(hoten)="data">
          <b-media vertical-align="center">
            <b-link
              :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
              class="font-weight-bold d-block text-nowrap text-primary"
            >
              {{ data.item.hoten }}
            </b-link>
            <small class="text-muted">@{{ data.item.username }}</small>
          </b-media>
        </template>
        <template #cell(dien_thoai)="data">
          <b-media vertical-align="center">
            {{ data.item.dien_thoai }}
            <small class="text-muted">{{ data.item.email }}</small>
          </b-media>
        </template>
        <template #cell(so_lan_xem_con_lai)="data">
          <span v-if="data.item.so_lan_xem_con_lai != null">
            <b-badge
              variant="success"
              class="badge-glow"
            >
              {{ Number( data.item.so_lan_xem_con_lai).toLocaleString('vi', {minimumFractionDigits: 0}) }}
            </b-badge> /
            {{ (Number( data.item.so_lan_xem_con_lai) + Number (data.item.so_luong_khach)).toLocaleString('vi', {minimumFractionDigits: 0}) }}
          </span>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            dropright
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item :to="{ name: 'xem-chi-tiet-dai-ly', params: { id: data.item.id } }">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Xem chi tiết</span>
            </b-dropdown-item>

            <b-dropdown-item @click="suaKhach(data.item.id)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Sửa</span>
            </b-dropdown-item>

            <b-dropdown-item @click="napTien(data.item.id)">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Mua gói đầu tư</span>
            </b-dropdown-item>

            <b-dropdown-item @click="xoaKhach(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Xóa</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Dòng {{ dataMeta.from }} đến {{ dataMeta.to }} / {{ dataMeta.of }} bản ghi</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>

  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BMedia, BLink, BPagination, BDropdown, BDropdownItem,
  BCardTitle, BBadge,
  BCardHeader,
} from 'bootstrap-vue'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import { getUserData } from '@/auth/utils'
import NapTien from '@/views/users/dai-ly/NapTien.vue'
import TimKiem from '@/views/users/dai-ly/TimKiem.vue'
import KhachHangListAddNew from './KhachHangListAddNew.vue'
import useKhachHangList from './useKhachHangList'
import userStoreModule from '../userStoreModule'

export default {
  directives: {
    Ripple,
  },
  components: {
    BBadge,
    TimKiem,
    NapTien,
    KhachHangListAddNew,
    BCardTitle,
    BCardHeader,
    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BLink,
    BPagination,
    BDropdown,
    BDropdownItem,
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'app-user'
    const isTimKiemSidebarActive = ref(false)

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)
    const isNapTienSidebarActive = ref(false)

    const {
      fieldsTimKiem,
      fetchDaiLyList,
      xoaKhachHang,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useKhachHangList()

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]

    return {
      isTimKiemSidebarActive,
      fieldsTimKiem,
      // Sidebar
      isAddNewUserSidebarActive,
      isNapTienSidebarActive,
      fetchDaiLyList,
      xoaKhachHang,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    }
  },
  data() {
    return {
      currentUser: getUserData(),
    }
  },
  mounted() {
    this.$root.$on('timKiemDaiLy', data => {
      this.isTimKiemSidebarActive = false

      this.fieldsTimKiem = data
      this.thucHienTimKiem = true
      this.refetchData()
    })
  },
  methods: {
    xoaKhach(id) {
      this.$swal({
        title: 'Bạn có chắc chắn thực hiện việc này?',
        text: 'Dữ liệu sau khi xóa không thể phục hồi!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.xoaKhachHang(id, () => {
            this.$refs.refUserListTable.refresh()
          }, () => {
            this.$store.state.showBlock = true
          }, () => {
            this.$store.state.showBlock = false
          }, (message, type) => {
            this.showToast(type, 'Thông báo', 'BellIcon', message)
          })
        }
      }).catch(() => {
      })
    },
    suaKhach(id) {
      this.isAddNewUserSidebarActive = true
      this.$root.$emit('updateKhach', id)
    },
    napTien(id) {
      this.isNapTienSidebarActive = true
      this.$root.$emit('napTien', id)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
